import { useEffect } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

export const Alerts = (props) => {
  const { alert } = useSelector((state) => state.main);

  useEffect(() => {
    if (alert) {
      const { message, s, ok } = alert;
      
      switch (s) {
        case "error":
          Swal.fire({
            icon: 'error',
            title: 'Error Alert',
            text: message,
            confirmButtonText: 'OK'
          }).then(() => {
            if (ok) ok();
          });
          break;
        case "info":
          Swal.fire({
            icon: 'info',
            title: 'Information',
            text: message,
            confirmButtonText: 'OK'
          }).then(() => {
            if (ok) ok();
          });
          break;
        default:
          break;
      }
    }
  }, [alert]);

  return null; // SweetAlert2 renders modals directly, no need to return JSX
};
